import '../stylesheets/index.scss'

import VueSlimTable from './components/table.vue'

export default VueSlimTable
